/**
 * Aligned with monorepo `RegistrationTypeCode`
 * (`src/shared/domain/enums/registration-type-code.enum.ts`).
 */
export enum RegistrationTypeCode {
  visit = 'visit',
  delivery = 'delivery',
  parcel = 'parcel',
  frequentAccess = 'frequentAccess',
  providers = 'providers',
  fastPass = 'fastPass',
  priority = 'priority',
  selfRegistrationVisit = 'selfRegistrationVisit',
}

export interface RegistrationTypeFilterOption {
  value: RegistrationTypeCode;
  labelKey: string;
}

export interface RegistrationTypeLegendItem {
  value: RegistrationTypeCode;
  labelKey: string;
  /** CSS modifier on `.legends-color` (e.g. gray, blue-lg). */
  colorClass: string;
}

export interface PersonInvitationTypeFilterOption {
  value: string;
  labelKey: string;
}

export const REGISTRATION_TYPE_CATALOG: RegistrationTypeFilterOption[] = [
  { value: RegistrationTypeCode.fastPass, labelKey: 'invitations.types.fastpass' },
  { value: RegistrationTypeCode.delivery, labelKey: 'invitations.types.delivery' },
  { value: RegistrationTypeCode.parcel, labelKey: 'invitations.types.parcel' },
  { value: RegistrationTypeCode.frequentAccess, labelKey: 'invitations.types.frequentAccess' },
  { value: RegistrationTypeCode.providers, labelKey: 'invitations.types.provider' },
  { value: RegistrationTypeCode.visit, labelKey: 'invitations.types.visit' },
];

/**
 * Visits module color legend (fixed visual order). Visibility follows
 * `RegistrationTypeOptionsService` / WL `visits.registrationTypes`.
 */
export const REGISTRATION_TYPE_LEGEND: RegistrationTypeLegendItem[] = [
  {
    value: RegistrationTypeCode.fastPass,
    labelKey: 'invitations.types.fastpass',
    colorClass: 'gray',
  },
  {
    value: RegistrationTypeCode.frequentAccess,
    labelKey: 'invitations.types.frequentAccess',
    colorClass: 'blue-lg',
  },
  {
    value: RegistrationTypeCode.providers,
    labelKey: 'invitations.types.provider',
    colorClass: 'red',
  },
  {
    value: RegistrationTypeCode.visit,
    labelKey: 'invitations.types.visit',
    colorClass: 'green',
  },
  {
    value: RegistrationTypeCode.delivery,
    labelKey: 'invitations.types.delivery',
    colorClass: 'yellow',
  },
  {
    value: RegistrationTypeCode.parcel,
    labelKey: 'invitations.types.parcel',
    colorClass: 'blue',
  },
];

export const PERSON_INVITATION_TYPE_CATALOG: PersonInvitationTypeFilterOption[] = [
  { value: 'family', labelKey: 'status.family' },
  { value: 'trainer', labelKey: 'status.trainer' },
  { value: 'employee', labelKey: 'status.employee' },
  { value: 'provider', labelKey: 'status.provider' },
  { value: 'guest', labelKey: 'status.guest' },
  { value: 'visit', labelKey: 'status.visitor' },
];

export const LEGACY_HIDDEN_TYPES: RegistrationTypeCode[] = [
  RegistrationTypeCode.visit,
  RegistrationTypeCode.parcel,
  RegistrationTypeCode.delivery,
];

export const INVITATION_TYPE_MAP: Partial<Record<RegistrationTypeCode, string>> = {
  [RegistrationTypeCode.delivery]: 'deliveries',
  [RegistrationTypeCode.parcel]: 'packages',
  [RegistrationTypeCode.providers]: 'providers',
  [RegistrationTypeCode.frequentAccess]: 'frequentAccess',
};
